import { isIOS } from 'services/iosPurchases';

export const trackScreen = (screen) => {
  if (isIOS()) {
    return;
  }
  if (window.FirebasePlugin) {
    window.FirebasePlugin.logEvent('screen_view', {
      screen_name: screen,
      screen_class: screen
    });
  }
};

export const trackClick = (button) => {
  if (isIOS()) {
    return;
  }
  if (window.FirebasePlugin) {
    window.FirebasePlugin.logEvent('button_click', {
      button_name: button
    });
  }
};
